interface ActiveLane {
  name: string;
  id: number;
  active: boolean;
  color: string;
  acronym?: string;
}

export const activeLanes: ActiveLane[] = [
  {
    name: 'LaneManual/direct',
    id: 0,
    active: true,
    color: '#FF0D90',
    acronym: 'MD',
  },
  {
    name: 'LaneBus/direct',
    id: 1,
    active: true,
    color: '#FF2101',
    acronym: 'BD',
  },
  {
    name: 'LaneLeft2/direct',
    id: 2,
    active: true,
    color: '#0004ff',
    acronym: 'LD2',
  },
  {
    name: 'LaneLeft/direct',
    id: 3,
    active: true,
    color: '#03F3FF',
    acronym: 'LD',
  },
  {
    name: 'LaneEgo/direct',
    id: 4,
    active: true,
    color: '#FF740D',
    acronym: 'ED',
  },
  {
    name: 'LaneRight/direct',
    id: 5,
    active: true,
    color: '#7aff7a',
    acronym: 'RD',
  },
  {
    name: 'LaneRight/heuristic',
    id: 6,
    active: true,
    color: '#bdb500',
    acronym: 'RH',
  },
  {
    name: 'LaneRight2/direct',
    id: 7,
    active: true,
    color: '#009302',
    acronym: 'RD2',
  },
  {
    name: 'Absolute0',
    id: 8,
    active: true,
    color: '#791c81',
    acronym: 'GR0',
  },
  {
    name: 'Absolute1',
    id: 9,
    active: true,
    color: '#e55704',
    acronym: 'GR1',
  },
  {
    name: 'Absolute2',
    id: 10,
    active: true,
    color: '#4c0027',
    acronym: 'GR2',
  },
  {
    name: 'Absolute3',
    id: 11,
    active: true,
    color: '#1f4287',
    acronym: 'GR3',
  },
  {
    name: 'BusStop',
    id: 12,
    active: true,
    color: '#03F3FF',
  },
  {
    name: 'Bike',
    id: 13,
    active: true,
    color: '#03F3FF',
  },
];
